import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Tick icon — single confirmation checkmark. */
const TickIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M16.3105 5.47949C16.5058 5.28427 16.8223 5.28427 17.0176 5.47949C17.2128 5.67472 17.2128 5.9913 17.0176 6.18652L8.35091 14.8532C8.15565 15.0484 7.8391 15.0484 7.64384 14.8532L2.98242 10.1918C2.78721 9.99654 2.78721 9.67996 2.98242 9.48474C3.17768 9.28953 3.49423 9.28953 3.68949 9.48474L7.99738 13.7926L16.3105 5.47949Z" fill="currentColor" />
  </svg>
);

export default TickIcon;
